import Decimal from 'decimal.js';

Decimal.config({ precision: 36, rounding: 8, toExpNeg: -40, toExpPos: 40 });
